// Land progression: which biomes this player has reached, ever. Departing to
// a land unlocks it permanently (localStorage) for progress records. Public
// runs always start in the valley; later lands are earned through one tour.

import type { BiomeId } from './world';

const KEY = 'takemetoyourledger:lands:v1';

export const LAND_ORDER: readonly BiomeId[] = ['valley', 'mesa', 'snow', 'moor', 'town', 'mars', 'moon'];

/** Short cockpit labels: the full cinematic names belong to land reveals. */
export const LAND_HUD_LABEL: Readonly<Record<BiomeId, string>> = {
  valley: 'VALLEY',
  mesa: 'MESA',
  snow: 'SNOW',
  moor: 'MOORS',
  town: 'TOWN',
  mars: 'MARS',
  moon: 'MOON',
};

interface LandState {
  unlocked: BiomeId[];
}

/** Pure: coerce anything (including the old `{ selected }` schema) into a
 *  canonical progress record. Opening-land choice no longer exists. */
export function normaliseLandState(raw: unknown): LandState {
  const value = (raw ?? {}) as Partial<LandState>;
  const unlocked = LAND_ORDER.filter(id =>
    id === 'valley' || (Array.isArray(value.unlocked) && value.unlocked.includes(id)));
  return { unlocked };
}

function load(): LandState {
  try {
    return normaliseLandState(JSON.parse(localStorage.getItem(KEY) ?? 'null'));
  } catch {
    return normaliseLandState(null);
  }
}

function save(state: LandState): void {
  try { localStorage.setItem(KEY, JSON.stringify(state)); } catch { /* private mode */ }
}

export function unlockedLands(): BiomeId[] {
  return load().unlocked;
}

/** Permanently unlock a land the tour has reached. Returns true when it's new. */
export function unlockLand(id: BiomeId): boolean {
  const state = load();
  if (state.unlocked.includes(id)) return false;
  save(normaliseLandState({ unlocked: [...state.unlocked, id] }));
  return true;
}
